var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06065 4.25H7.00065V0.916667C7.00065 0.55 6.70065 0.25 6.33398 0.25H3.66732C3.30065 0.25 3.00065 0.55 3.00065 0.916667V4.25H1.94065C1.34732 4.25 1.04732 4.97 1.46732 5.39L4.52732 8.45C4.78732 8.71 5.20732 8.71 5.46732 8.45L8.52732 5.39C8.94732 4.97 8.65399 4.25 8.06065 4.25ZM0.333984 10.9167C0.333984 11.2833 0.633984 11.5833 1.00065 11.5833H9.00065C9.36732 11.5833 9.66732 11.2833 9.66732 10.9167C9.66732 10.55 9.36732 10.25 9.00065 10.25H1.00065C0.633984 10.25 0.333984 10.55 0.333984 10.9167Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.45825f176a3f48cfffc681656305f608.svg";
export { ForwardRef as ReactComponent };